import React, { useEffect, useState } from 'react';
import classnames from "classnames";
import Styles from "./styles.module.scss";
import Headline4 from "../../components/headings/Headline4";
import { Icon } from '@iconify/react';
import DeleteModal from '../../modal/createResource/deleteModal';
import { submitDetails, getDetails } from './services';
import NotificationAlert from "../../components/notification";
// import mixpanelData from '../../utils/mixpanel';
import Education from '../../dashboardFormComponents/accademicForm'
import mixpanelData from '../../utils/mixpanel';


interface Props {

    LanguageHandler: (event: any) => void
    getUserDetails: (event: any) => void
    defaultValues: {
        education: {degree: string, institution: string, startDate: number, endDate:number, action: string}[],
    },
    loginId: string | null ,
    userLoginId: string | null
    displayNotification: (event: string) => void
  
  }

  const Academic: React.FC<Props> = ({
    getUserDetails,
    loginId,
    displayNotification,
    defaultValues,
    userLoginId,
  }) => {
 
 
    const { v4: uuidv4 } = require('uuid');
    // const [eduvisible, setEduvisible] = useState(true);
    const [visibleDeleteModal, setVisibleDeleteModal] = useState(true);
    const [section, setSection] = useState<string>('')
    const [educationIndex, setEducationIndex] = useState<number>(-1)
    const [education, setEducation] = useState<{institution: string, degree: string, startDate: number, endDate: number, educationId?: string}[]>([]);
    const [notification, setNotification] = useState<boolean>(false)
    const [message, setMessage] = useState<string>('')
    const [newEducation, setNewEducation] = useState<boolean>(false)
    const [editEducation, setEditEducation] = useState<boolean>(false)

    useEffect(() => {
        if (defaultValues){
            setEducation(defaultValues.education)
            // setLanguage(defaultValues.language)
        }
    }, [])

    const addEducationModal = () => {
        // setEduvisible(!eduvisible);
        setEducationIndex(-1)
        setNewEducation(true)
    };

      const submitEducation = (data:any) => {
        
        let value = {
            "action": data.action, 
            "section": 'education',
            "loginId": loginId,
            "userLoginId": userLoginId,
            "submittedBy": 'RECRUITER',
            "education": {
                "educationId": data.educationId ? data.educationId : uuidv4(),
                "degree": data.degree,
                "institution": data.institution,
                "startDate": data.startDate,
                "endDate": data.endDate
          } }

          submitDetails(value).then((response: any) => {
              if( response && response.status === 1) {

                mixpanelData('New TG - Education Details updated', {
                    'source': "Recruiter updates education",
                    'Success':  true,
                    'distinct_id': localStorage.getItem('Email'),
                    'Recruiter email': localStorage.getItem('Email'), 
                    'Phone number': response && response.data[0].profile_metadata.phoneNumber ,
                    'Candidate name': response && (response.data[0].profile_metadata.firstName + ' ' + response.data[0].profile_metadata.lastName),
                    'Candidate email': response.data[0].profile_metadata.email,
                    "educationId": data.educationId ? data.educationId : uuidv4(),
                    "Degree": data.degree,
                    "Institution": data.institution,
                    "Start date": new Date(data.startDate).toDateString(),
                    "End date": new Date(data.endDate).toDateString(),
                    'Candidate loginid': loginId
                  })

                onClose();
                getDetails(loginId).then((resp: any) => {                  
                    setEducation(resp.data[0].profile_metadata.education)    
                    getUserDetails(loginId)  
                    displayNotification('Details saved successfully');
                        // setMessage('Details saved successfully')
                        // setNotification(true)
                        // setTimeout(() => {
                        // setNotification(false)
                        // }, 3000);      
                })
              }
          })
      }

      const deleteModal = () => {
        setVisibleDeleteModal(!visibleDeleteModal)
        setEducationIndex(-1)
      }

      const Delete = (section: string) => {
          
        let value = {}
        if ( section === 'education'){
            value = {
                "action": 'delete', 
                "section": 'education',
                "userLoginId": userLoginId,
                "submittedBy": 'RECRUITER',
                "loginId": loginId,
                "education": {
                    "educationId":  education[educationIndex].educationId
              } 
            }
        }
        
        submitDetails(value).then((response: any) => {
            if( response && response.status === 1) {

                mixpanelData('New TG - Education Details Deleted', {
                    'source': "freelancer deletes education details",
                    'Success':  true,
                    'distinct_id': response && response.data[0].profile_metadata.email,
                    'Candidate email':response.data[0].profile_metadata.email,
                    'Candidate name': response && (response.data[0].profile_metadata.firstName + ' ' + response.data[0].profile_metadata.lastName),
                    'Education name': education[educationIndex].degree,
                    'Education id': education[educationIndex].educationId
                  })
                

              getDetails(loginId).then((resp: any) => {             
                  deleteModal();     
                  setEducation(resp.data[0].profile_metadata.education)     
                    getUserDetails(loginId)  
                    displayNotification('Details deleted successfully')


              })
            }
        })
      }
      const onClose = () => {
        setEducationIndex(-1)
        setNotification(false)
        setNewEducation(false)
        setEditEducation(false)
       }

    return (
            <section>
                 {notification && <NotificationAlert onClose={onClose } closable={true} >
                    {message}
                 </NotificationAlert> }

                {/* {!eduvisible && ( <EducationModal ClickHandler={submitEducation} defaultValues={educationIndex !== -1 ? education[educationIndex] : ''} onClose={addEducationModal} /> )} */}
                {!visibleDeleteModal && ( <DeleteModal onClose={deleteModal} onSubmit={Delete} section={section}/> )}
                
                {/* <Headline4>Academic Details</Headline4> */}
                { education && education.map((item, key) => {
                    return(
                        <div>
                            { key !== educationIndex ? <div className={Styles.workExpWrapper} key={key}>
                                <div className={classnames(Styles.workExpCard, Styles.eduExpCard)}>
                                    <div className={Styles.workExpHead}>
                                        <div>
                                            <h6>{item.degree}</h6>
                                            <div className={Styles.expDate}> {item.institution} { item.institution && '|'} { item.startDate ? new Date(item.startDate).toDateString() : ''}{ (item.startDate || item.endDate) && '-' }{item.endDate ? new Date(item.endDate).toDateString() : ''}</div>
                                        </div>
                                        <div className={Styles.actions}>
                                            <Icon icon="lucide:edit-2" onClick={() => {setEditEducation(true); setEducationIndex(key)}}/>
                                            <Icon icon="mdi:trash-can-outline" onClick={() => {deleteModal(); setEducationIndex(key); setSection('education')}} />
                                        </div>
                                    </div>
                                </div> 
                             </div> : <Education ClickHandler={submitEducation} defaultValues={educationIndex !== -1 ? education[educationIndex] : ''} onClose={onClose} />}
                        </div>
                    )
                })}
                <div>
                { newEducation ? <Education ClickHandler={submitEducation} defaultValues={educationIndex !== -1 ? education[educationIndex] : ''} onClose={onClose} />
                : <button className={Styles.addWorkHistory}  onClick={addEducationModal}><Icon icon="fluent:add-circle-28-regular" />Education</button> }
                </div>
            </section>
        );
}
export default Academic